<template>
  <el-drawer
    title="服务及免责说明"
    :visible.sync="drawerAgreementVisible"
    direction="rtl"
    size="70%"
    @close="drawerAgreementVisibleClose"
  >
    <div class="box">
      <p class="tAlign">“WoYou工资”用户服务说明及免责申明</p>
      <p class="tRight">更新日期：2023年9月15日</p>
      <p class="tRight">生效日期：2023年9月15日</p>
      <p>
        瑞启及瑞启关联方以及所提供的“WoYou工资”服务平台（以下或称“我们”）非常注重保护用户（“您”）的个人信息、隐私及消费者权益。
      </p>
      <p>
        我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。我们通过本政策向您清晰地介绍在使用我们的相关产品/服务时，我们如何收集、使用、处理、或分享您的个人信息，以及我们为您提供的访问、更正、删除和保护这些信息的方式；以及具体的服务方式。本政策有特别规定的，以本政策为准；本政策未载明之处，请参照《“WoYou工资”隐私政策》。如您对本政策有任何疑问，您可以“联系我们”中提供的方式与我们联系。
      </p>
      <p>本政策将帮助您了解以下内容：</p>
      <p>1、“WoYou工资”平台提供的金融导流业务服务</p>
      <p>
        需要注意的是，瑞启及瑞启关联方以及“WoYou工资”平台，并不为您直接提供金融相关的服务。“WoYou工资”平台内，所有涉及金融的业务，均由我司战略合作伙伴提供。
      </p>
      <p>
        瑞启、瑞启关联方以及“WoYou工资”仅为战略合作伙伴提供互联网导流技术服务。实质业务依托于具有合法合规资质的战略合作伙伴所提供的战略合作协议中关于业务的规定以及技术接口及业务底层完成。您可放心使用。
      </p>
      <p>
        也因此，我司将不承担您在平台内，使用由我司战略合作伙伴所提供的相关业务所造成的连带责任。
      </p>
      <p>
        我司与金融业务有关的战略合作伙伴（包括且不限于中国广发银行，中国平安银行，中国厦门国际银行等），我们均已为您确认其具有从事相关业务合法合规的资质，并采用商业合同的方式予以约束。
      </p>
      <p>
        我司可能被认为与金融业务有关，但实质为技术导流的功能包括但不限于如下：
      </p>
      <p>1、【工资卡】开卡</p>
      <p>2、【信用卡】开卡</p>
      <p>3、【社保卡】开卡</p>
      <p>4、【养老金理财预约】</p>
      <p>5、【工资直发】等</p>
      <p>2、“WoYou工资”平台提供的保险导流业务服务</p>
      <p>
        需要注意的是，瑞启及瑞启关联方以及“WoYou工资”平台，并不为您直接提供保险相关的服务。“WoYou工资”平台内，所有涉及保险的业务，均由我司战略合作伙伴提供。
      </p>
      <p>
        瑞启、瑞启关联方以及“WoYou工资”仅为战略合作伙伴提供互联网导流技术服务。实质业务依托于具有合法合规资质的战略合作伙伴所提供的战略合作协议中关于业务的规定以及技术接口及业务底层完成。您可放心使用。
      </p>
      <p>
        也因此，我司将不承担您在平台内，使用由我司战略合作伙伴所提供的相关业务所造成的连带责任。
      </p>
      <p>
        我司与保险业务有关的战略合作伙伴（包括且不限于中国中意保险，中国泰康保险，中国阳光经纪有限公司等），我们均已为您确认其具有从事相关业务合法合规的资质，并采用商业合同的方式予以约束。
      </p>
      <p>
        我司可能被认为与保险业务有关，但实质为技术导流的功能包括但不限于如下：
      </p>
      <p>1、【雇主责任险】功能</p>
      <p>2、【团体意外险】功能</p>
      <p>3、【个人意外险】功能</p>
      <p>4、【家政责任险】功能</p>
      <p>3、“WoYou工资”对平台内信息的管理、使用及保护说明</p>
      <p>
        需要注意的是，瑞启及瑞启关联方以及“WoYou工资”平台使用了互联网技术和部分人工智能技术，对您提交及使用的数据进行分析及处理，以为您提供更好的服务。但相关信息的处理，使用及保护也必然会受到技术手段的制约，以及具体业务需求的影响。对于具体信息的说明，请您参照《“WoYou工资”隐私政策》
      </p>
    </div>
  </el-drawer>
</template>
<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      drawerAgreementVisible: false,
    };
  },
  methods: {
    drawerAgreementVisibleClose() {
      this.$emit("close");
    },
  },
  watch: {
    visible(val) {
      this.drawerAgreementVisible = val;
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 25px;
  width: 100%;
  p {
    font-size: 16px;
    line-height: 38px;
  }
}
</style>